// import Logo from '../assets/images/IETBHEC.png'
// import C1 from '../assets/images/c1.jpg'
import S0 from '../assets/images/San Jose State University.jpg'
import S3 from '../assets/images/Logo_HCM-UTE.png'
import S6 from '../assets/images/sp6.png'
import Arun from '../assets/images/vice_chancellor_img.jpg'
import Alex from '../assets/images/Alex Stojcevski.jpg'
import Video from '../assets/IETBHEC26 WELCOME.mp4'
import { NavLink } from "react-router";

function Home() {
    return (
        <div>
            <div className="row">
                <div className="col-md-3">
                    <table width="100%" border="1" cellspacing="0" className='table_important_date'>
                        <tbody>
                            <tr className='outline-table'>
                                <td colSpan="2" className='home_important_dates'>📌Important Dates</td>
                            </tr>
                            <tr>
                                <td className='word_wrap'>Full Paper Submission by</td>
                                <td className='red_text'>15 Mar '26</td>
                            </tr>
                            <tr>
                                <td className='word_wrap'>Notification of Acceptance of Full Paper</td>
                                <td className='red_text'>30 Mar '26</td>
                            </tr>
                            <tr>
                                <td className='word_wrap'>Early Bird Registration Opens</td>
                                <td className='red_text'>05 Jan '26</td>
                            </tr>
                            <tr>
                                <td className='word_wrap'>Early Bird Registration Closes</td>
                                <td className='red_text'>30 Apr '26</td>
                            </tr>
                            <tr>
                                <td className='word_wrap'>Conference Dates</td>
                                <td className='red_text'>05-07 July '26</td>
                            </tr>
                        </tbody>
                    </table>
                    <br></br>
                    <p className="home_welcome"><strong>IETBHEC'26 WELCOME</strong></p>
                    <video width="100%" controls>
                        <source src={Video} type="video/mp4"/>
                            Your browser does not support the video tag.
                    </video> 
                </div>
                <div className="col-md-6">
                    <div>
                        <h4><strong>Forging Futures Through Collaboration and Skill Empowerment: From Learning to Leading</strong></h4>

                    </div>
                    <br></br>
                    <div>
                        <p>International Engineering, Technology, Business and Health Education Conference (IETBHEC’26) is the fifth conference in the IETEC series, bringing together global stakeholders in engineering, technology, business, and health education to explore new capacities essential for building environmentally and socially sustainable economies.</p>
                        <p>This conference will spotlight the latest trends and developments shaping the future of education and practice across these fields, with a strong focus on collaboration and skill empowerment.</p>
                        <br></br>
                        <p><span className="font-weight-bold">IETBHEC’26 Highlights</span></p>
                        <ul id='home-highlights'>
                            <li><strong>Interactive Masterclasses</strong> by international experts</li>
                            <li><strong>Plenary Sessions and Special Sessions</strong> on PBL, CDIO, accreditation and rankings</li>
                            <li><strong>Panel Discussion</strong> on industry collaboration, internationalisation, etc.</li>
                            <li><strong>Strong Industry Presence</strong> and Networking Opportunities</li>
                            <li><strong>Indexed Proceedings</strong> (scholarly publisher & Scopus)</li>
                            <li><strong>Best Paper Awards</strong> & Journal Publication Invitations</li>
                            <li><strong>Exhibitions</strong> of books, software, and educational tools</li>
                            <li><strong>Opportunities for International Collaboration</strong></li>
                        </ul>

                    </div>
                    <br></br>
                    <div>
                        <p>We invite research papers on emerging trends, innovations, and best practices in engineering, technology, business and health education.</p>
                        <p>📍 Join us in vibrant Singapore! </p>

                        <p className='no-newline-after-p'><span className="font-weight-bold">General Chairs</span></p>
                        <p><span className="font-weight-bold">IETBHEC’26 Organising Committee</span></p>
                        <div className='chairs-flex-box'>
                            <div>
                                <img src={Arun} alt='' width="100%" />
                                <p className='no-margin-bottom'>Professor Arun Patil</p>
                            </div>
                            <div>
                                <img src={Alex} alt='' width="100%" />
                                <p className='no-margin-bottom'>Professor Alex Stojcevski</p>
                            </div>
                        </div>
                        <br></br>
                        <NavLink to="/registration"><button id='hero-button'>Register here</button></NavLink>
                    </div>
                </div>
                <div className="col-md-3">
                    <div>
                        <p className='font-italic'>Proudly supported by:</p>
                    </div>
                    <img src={S0} alt='' width="50%" />
                    <img src={S3} alt='' width="50%" />
                    <img src={S6} alt='' width="50%" />
                </div>
            </div>
        </div>
    )
}

export default Home